import { RadioGroup } from '@aloft/toolkit-sui';

import { Controller } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.ts';
import { DepreciationQuestion } from './DepreciationQuestion.tsx';

type Props = {
  question: string;
  trueLabel: string;
  falseLabel: string;
  fieldName: string;
  forceHorizontal?: boolean;
  trueFirst?: boolean;
  isDisabled?: boolean;
};

export const DepreciationToggle = ({
  question,
  trueLabel,
  falseLabel,
  fieldName,
  forceHorizontal,
  trueFirst,
  isDisabled,
}: Props) => {
  const { control } = useZodFormContext();
  const items = trueFirst
    ? [
        { label: trueLabel, value: 'true' },
        { label: falseLabel, value: 'false' },
      ]
    : [
        { label: falseLabel, value: 'false' },
        { label: trueLabel, value: 'true' },
      ];

  return (
    <DepreciationQuestion question={question}>
      <Controller
        name={fieldName}
        control={control}
        render={({ field }) => (
          <RadioGroup
            size="sm"
            forceHorizontal={forceHorizontal}
            items={items}
            columnGap={forceHorizontal ? '1.5rem' : undefined}
            gap={forceHorizontal ? undefined : '.5rem'}
            {...field}
            isDisabled={isDisabled}
          />
        )}
      />
    </DepreciationQuestion>
  );
};
